/**
 * Lightweight platform counts.
 *
 * These two integers are extracted here so the heavy industry data module
 * (config/industryConfig.js — 516 industries, ~16KB gzip) stays OUT of the
 * critical/eager bundle. Only components that render the actual industry
 * lists import industryConfig directly, and those are lazy-loaded.
 *
 * SOURCE OF TRUTH: config/industryConfig.js
 *   - TOTAL_INDUSTRY_COVERAGE === getIndustryCount()
 *   - INDUSTRY_CATEGORIES_COUNT === INDUSTRY_CATEGORIES.length
 * If you add/remove industries or categories there, update these numbers.
 */
export const TOTAL_INDUSTRY_COVERAGE = 516;
export const INDUSTRY_CATEGORIES_COUNT = 24;
